import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ConfigurationService } from '../../services/configuration.service';


@Injectable({
  providedIn: 'root'
})
export class VisitChannelsService {

  constructor(protected http: HttpClient,
    protected configurations: ConfigurationService) {
  }

  save(visitChannels: any) {
    return this.http.post(this.configurations.apiAddress + "/api/VisitChannels/save", visitChannels);
  }

  search(searchText: string) {
    let myParams = new HttpParams()
      .set('name', searchText == undefined ? "" : searchText)
    return this.http.get(this.configurations.apiAddress + '/api/VisitChannels/getAll', { params: myParams });
  }

  delete(id: number) {
    return this.http.delete(this.configurations.apiAddress + '/api/VisitChannels/delete/' + id);
  }

  getById(id: number) {
    return this.http.get(this.configurations.apiAddress + '/api/VisitChannels/getById/' + id);
  }

  getAll() {
    return this.http.get(this.configurations.apiAddress + '/api/VisitChannels/getAll/');
  }
}
